import React, { useEffect, useState } from "react";
import { RunnerUpHeader } from "../../ui/runnerUpHeader/RunnerUpHeader";
import Button from "../../library/components/Button";
import "./index.css";
import {useNavigate } from "react-router";
import PrecountingTabs from "./PreCountingTabs/PreCountingTabs";
import { parseJwt } from "../utilities/utils";
import {
  useGetStatesRequestQuery,
  useGetConstituencyRequestQuery,
  useGetPcByStateQuery,
  useMarkScanningCompletedMutation,
} from "../../services/announceElection";
import { useGetForm13CQuery } from "../../services/preCountingServices";
import LeftMenu from "../AnalyticsModule/Left";
import NoElection from "../NoElection";
import { useGetElectionDetailsQuery } from "../../services/announceElection";
import moment from "moment";
import scannerImage from "../../images/scanner.png";
import TimerCountdown from "../../library/components/FlipCountDownClock/flipCountDown";
import WorkingFlipDate from '../../library/components/WorkingFlipDate/WorkingFlipDate'
import CustomModal from "../../library/components/Modal/modal";
import { Validators } from "../../library/utilities/Validator";
import { ALERT_TYPE_SUCCESS, FILED_IS_REQUIRED } from "../../constants/constants";
import InputField from "../../library/components/InputField";
import { createAlert } from "../../features/alert/alerts";
import { useDispatch } from "react-redux";
import click from "../../dashboardicon/click.svg"
export const PreCounting = () => {
  const [isForm13CSkip, setIsForm13CSkip] = useState(true);
  const { data: ElectionDetail, isSuccess, refetch } = useGetElectionDetailsQuery("Precounting");
  const { data: form13c } = useGetForm13CQuery("", { skip: isForm13CSkip });
  const [skipAc, setSkipAc] = useState(true);
  const [skipPc, setSkipPc] = useState(true);
  const [] = useState(1);
 
  const { data: getStateList } = useGetStatesRequestQuery();
  const constType = parseJwt(localStorage.access_token)?.constituencyType;
  const stateCd = parseJwt(localStorage.access_token).authorizedStates?.[0];

  const state = getStateList?.filter((item) => {
    return item.stateCd === stateCd;
  })?.[0].stateName;

  const constACNumber = parseJwt(localStorage.access_token)?.authorizedAcs?.[0];
  const constPCNumber = parseJwt(localStorage.access_token)?.authorizedPcs?.[0];
  const [constName, setConstName] = useState({});
  const [data,setData] = useState();
  const [errorValue, setErrorValue] = useState({});
  const [showModal,setShowModal] = useState(false)
  const { data: getAcList } = useGetConstituencyRequestQuery(stateCd, {
    skip: skipAc,
  });
  const { data: getPcList } = useGetPcByStateQuery(stateCd, { skip: skipPc });
  const [markScannedComplete,datap]=useMarkScanningCompletedMutation();
  const role = localStorage?.userrole
  const dispatch = useDispatch()
  // const list = [
  //   { key: "State :", value: state },
  //   {
  //     key: "Constituency :",
  //     value: `${constName.acNo} - ${constName.acName} (${constType})`,
  //   },
  // ];

  let navigate = useNavigate();
  const onScanBallot = async () => {
    navigate("/ro/scanBallot");
  };
  

  useEffect(() => {
    if (ElectionDetail && isSuccess) {
      if (ElectionDetail?.message !== "Success") {
        setIsForm13CSkip(true);
      } else if (ElectionDetail?.message === "Success") {
        setIsForm13CSkip(false);
      }
    }
  }, [ElectionDetail, isSuccess]);

  useEffect(() => {
    if (constType === "AC") {
      let acName = getAcList?.filter((item) => {
        return item.asmblyNo === constACNumber;
      })?.[0].asmblyName;

      setConstName({ acName: acName, acNo: constACNumber });
    } else if (constType === "PC") {
      let pcName = getPcList?.filter((item) => {
        return item.prlmntNo == constPCNumber;
      })?.[0].parliamentName;
      setConstName({ acName: pcName, acNo: constPCNumber });
    } else {
    }
  }, [getAcList, getPcList]);

  useEffect(() => {
    if (constType === "AC") {
      setSkipAc(false);
    } else if (constType === "PC") {
      setSkipPc(false);
    } else {
      //error
    }
  }, []);

  // useEffect(() => {
  //   var startDate = moment(form13c?.payload?.cutOffDate).format(
  //     "MM-DD-YYYY HH:mm:ss"
  //   );
  //   setDate(startDate);
  // }, [form13c]);

  const refreshDate = ()=>{
    refetch()
  }

  const onClose = () => {
    setShowModal(false);
  };

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getErrorValue = (key, value) => {
    let error = { ...errorValue };
    if (value && value.message) {
      setErrorValue({ ...errorValue, [key]: value.message });
    } else {
      delete error[key];
      setErrorValue(error);
    }
  };

  const submitBallotCount = () =>{
    let error = {};
    if (!data?.till8AM || data?.till8AM === "") {
      error["till8AM"] = "This field is required";
    }

    if (!data?.after8AM || data?.after8AM === "") {
      error["after8AM"] = "This Field is required";
    }

    if (!data?.epbRejected || data?.epbRejected === "") {
      error["epbRejected"] = "This Field is required";
    }

    if (Object.keys(error).length) {
      setErrorValue(error);
      return;
    }

    markScannedComplete({
      constType: parseJwt(localStorage.access_token)?.constituencyType,
      constNo: parseJwt(localStorage.access_token)?.authorizedAcs?.[0],
      pbReceivedTill8AM: data?.till8AM,
      pbReceivedAfter8AM: data?.after8AM,
      totalEpbRejectedWithoutScanning: data?.epbRejected,
    })
    
  }

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: 'Success',
      }),
    )
  }
  useEffect(()=>{
    if(datap.isSuccess){
      onSuccess("Scanning Completed Successfully")
      refetch()
      setShowModal(false)
    setData({})
    }
  },[datap.isSuccess])

  return (
    <LeftMenu>
          <CustomModal
        className="custom_modal confirm-modal"
        show={showModal}
        onClose={onClose}
        size="55%"
        closeIcon={true}
        // modalTitle={props.localLang?.CONFIRMATION_POPUP?.TITLE}
        children={
     <>
     <RunnerUpHeader
                    label={
                      <>
                        <p>
                          Do You Want To Complete the Scanning
                        </p>
                      </>
                    }
                  />
         <div className="row mt-4">
          <div className="col-md-12" style={{display:"flex"}}>
          <InputField
                inputClass="col-md-6"
                labelClass="col-md-6 m-auto"
                label="Total Ballot Recieved till 8 AM"
                name="till8AM"
                disabled={false}
                required={true}
                type="number"
                value={data?.till8AM}
                onChange={(val) => handleChange("till8AM", val)}
                getError={(value) => getErrorValue("till8AM", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  }, 
                ]}
                getErrorValue={(val) => getErrorValue("till8AM", val)}
                Error={errorValue}
              />
          </div>
          <div className="col-md-12 mt-1" style={{display:"flex"}}>
          <InputField
                inputClass="col-md-6"
                labelClass="col-md-6 m-auto"
                label="Total Ballot Recieved After 8 AM"
                name="after8AM"
                disabled={false}
                required={true}
                type="number"
                value={data?.after8AM}
                onChange={(val) => handleChange("after8AM", val)}
                getError={(value) => getErrorValue("after8AM", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  }, 
                ]}
                getErrorValue={(val) => getErrorValue("after8AM", val)}
                Error={errorValue}
              />
          </div>
          <div className="col-md-12 mt-1" style={{display:"flex"}}>
          <InputField
                inputClass="col-md-6"
                labelClass="col-md-6 m-auto"
                label="Total e-PB Rejected without Scan"
                name="epbRejected"
                disabled={false}
                required={true}
                type="number"
                value={data?.epbRejected}
                onChange={(val) => handleChange("epbRejected", val)}
                getError={(value) => getErrorValue("epbRejected", value)}
                validators={[
                  {
                    check: Validators.required,
                    message: FILED_IS_REQUIRED,
                  }, 
                ]}
                getErrorValue={(val) => getErrorValue("epbRejected", val)}
                Error={errorValue}
              />
          </div>
          <div className="col-md-6" style={{marginTop:"-21px"}}>
            <p style={{ 
            fontSize: "11px",
    color: "red",
    padding: "0 4px 0px 4px"}}>( e-PB Received till 8 AM that was rejected without scanning.(e-PB for which Serial No was not generated for Form 13-C))</p>
          </div>
          <div className="col-md-12 mt-4" >
                   <p  style={{margin:"auto", color:"red",fontWeight:700,fontSize:"15px"}}>Note: Please ensure that scanning of Form 13-C, Form 13-A and Form 13-B for all received e-PB has been completed for your constituency by all Counting Supervisors. Once you mark it is complete, scanning of e-PB will be disabled. </p>
                    </div>
          <div className="col-md-12  m-auto text-center">
          <Button
                          value="Mark Scanning Complete "
                          btnClass="btn btn-danger mt-2"
                          onClick={()=>submitBallotCount()}
                           hidden={false}
                        />
          </div>
         </div>
     </>
        }
      />
      {isSuccess && ElectionDetail?.message === "Success" && ElectionDetail?.payload?.[0]?.preCountingFlag !=="Y" ? (
        form13c && (
          <WorkingFlipDate 
          hours={ElectionDetail?.payload?.[0]?.hours} 
          minutes={ElectionDetail?.payload?.[0]?.minutes} 
          days={ElectionDetail?.payload?.[0]?.days}
          seconds={ElectionDetail?.payload?.[0]?.seconds}
          image={true}
          imagePath={scannerImage}
          imageClass={"preCounting_scanner_img"}
          message={"Left for e-PB Pre-Counting process to start"}
          messageClass={"returningOfficer_countdown"}
          disable={ElectionDetail?.payload?.[0]?.timerVariable}
          refreshDate={refreshDate}
          scanning={true}
          >
            <>
              {" "}
              <div className="pre-count my-2 container">
                <div className="box" style={{ overflow: "hidden" }}>
                <p style={{cursor:"pointer",
    fontSize: "14px",
    textAlign: "end",
    margin: "auto",}} onClick={()=>navigate('/ro/TestQrScanner')}>Click here to test your QR Code Scanner <img className={"clickhereIcon"} src={click} style={{height:"25px",width:"25px"}}/></p>
                  <RunnerUpHeader
                    label={
                      <>
                        <p>
                          Pre-Counting
                          <span style={{ marginLeft: "230px", color: "white" }}>
                            State: {state}<span style={{ marginLeft: "15px", color: "white" }}></span> Constituency: {constName.acNo} -{" "}
                            {constName.acName} ({constType})
                          </span>
                        </p>
                      </>
                    }
                    // label={`Pre-Counting${'&nbsp:'}State:${state} Constituency:${constName.acNo} - ${constName.acName} (${constType})`}
                    // search={
                    //   <label className="red-label">
                    //     {moment(new Date()).format("MM-DD-YYYY HH:mm:ss") >= date
                    //       ? "Scanning enabled"
                    //       : `Scanning will be enabled on ${moment(
                    //           form13c?.payload?.cutOffDate
                    //         ).format("DD-MMMM-YYYY HH:mm A")}`}
                    //   </label>
                    // }
                  />
                  <>
                    <div className=" row head_key-vlaue">
                      <div className="col-md-9">
                        {" "}
                        {/* <HeadWithKeyValue list={list} /> */}
                      </div>
                      <div className="col-md-3">
                        <Button
                          value="scan ballot paper"
                          btnClass="button-class"
                          onClick={onScanBallot}
                           hidden={true}
                        />
                      </div>
                    </div>
                    <div className=" m-0 pt-3">
                      <PrecountingTabs />
                      {}
                    </div>
                  
                  </>
                </div>
               {role ==="ro" &&  <div className="box " style={{ overflow: "hidden" }}>
               <div className="row">
               <div className="col-md-8 " style={{margin:"auto"}}>
                   <p  style={{margin:"auto", color:"red",fontWeight:700,fontSize:"15px"}}>Kindly Mark the scanning completed after the completion of Pre-Counting of Form 13C/13A/13B</p>
                    </div>
                    <div className="col-md-4">
                    <Button
                          value="Scanning Completed"
                          btnClass="btn btn-danger"
                          onClick={()=>setShowModal(true)}
                           hidden={false}
                        />
                    </div>
               </div>
                      </div>}
              </div>
            </>
            </WorkingFlipDate>
        )
      ) : isSuccess && ElectionDetail?.message !== "Success" ? (
        <NoElection data={"No Election Scheduled for your Constituency"} />
      ) :isSuccess && ElectionDetail?.message === "Success" && ElectionDetail?.payload?.[0]?.preCountingFlag ==="Y" ? (
        <NoElection data={"Scanning of Form 13-C, Form 13-A and Form 13-B has been marked completed by the Returning Officer."} />
      ):(
        ""
      )}
    </LeftMenu>
  );
};
